import React, { lazy, Suspense } from "react";
import { BrowserRouter, Routes, Route } from "react-router"; // Corrected import
import { useAuth } from "./AuthContext";
import Home from "./Home";
import Account from "./Account";
import LoginSignUp from "./LoginSignUp";
import UserHeader from "./components/UserHeader";
import ProtectedRoute from "./ProtectedRoutes";
import LogInSignUpProtectedRoute from "./LogInSignUpProtectedRoute";
import ScrollToTop from "./components/ScrollToTop"; // Import ScrollToTop
import Header from "./Header";
import Footer from "./Footer";
import SubmissionDashboardProtectedRoute from "./SubmissionDashboardProtectedRoute";
import ApplicationSubmission from "./ApplicationSubmission";
const Donate = lazy(() => import("./Donate"));
const Faq = lazy(() => import("./Faq"));
const ScholarshipRequirements = lazy(() => import("./ScholarshipRequirements"));
const NotFound = lazy(() => import("./NotFound"));
const ThankYou = lazy(() => import("./ThankYou"));
const ApplicationNotOpen = lazy(() => import("./ApplicationNotOpen"));
const SubmissionDashboard = lazy(() => import("./SubmissionDashboard"));
const ArchivedApplications = lazy(() => import("./ArchivedApplications"));

import "./account.css";

function App() {
  const { user } = useAuth();

  return (
    <BrowserRouter>
      <ScrollToTop />
      <Header />
      {user ? <UserHeader currentUser={user} /> : null}
      <Suspense
        fallback={
          <div
            style={{
              height: "70vh",
              display: "flex",
              alignItems: "center",
              justifyContent: "center",
            }}
          >
            <span className="page-loader"></span>
          </div>
        }
      >
        <Routes>
          {/* Public Routes */}
          <Route path="/" element={<Home />} />
          <Route path="/home" element={<Home />} />
          <Route path="/donate" element={<Donate />} />
          <Route path="/faq" element={<Faq />} />
          <Route
            path="/scholarship-requirements"
            element={<ScholarshipRequirements />}
          />
          <Route
            path="/application-not-open"
            element={<ApplicationNotOpen />}
          />
          <Route path="/thank-you" element={<ThankYou />} />

          {/* Protected Routes (Login/Signup) */}
          <Route element={<LogInSignUpProtectedRoute user={user} />}>
            <Route path="/login" element={<LoginSignUp />} />
          </Route>

          {/* Protected Routes (Authenticated Users) */}
          <Route element={<ProtectedRoute user={user} />}>
            <Route path="/account" element={<Account />} />
          </Route>

          {/* Protected Routes (Authenticated Users) */}
          <Route element={<SubmissionDashboardProtectedRoute user={user} />}>
            <Route
              path="/submission-dashboard"
              element={<SubmissionDashboard />}
            />
            <Route
              path="/submission-dashboard/application-submission"
              element={<ApplicationSubmission />}
            />
            <Route
              path="/submission-dashboard/archives"
              element={<ArchivedApplications />}
            />
          </Route>

          {/* 404 */}
          <Route path="*" element={<NotFound />} />
        </Routes>
      </Suspense>
      <Footer />
    </BrowserRouter>
  );
}

export default App;
